import React,{Component} from 'react'
import {ToastContainer, toast} from 'react-toastify'
import {ThemeProvider} from '@material-ui/core/styles'
import theme from  '../shared/mui-theme'
import Header from './Header'
import Form from './Form'
import './styles.sass'
import {saveMarketingAttrsFromHref} from '../landing/App'

class App extends Component
	render: ()->
		<ThemeProvider theme={theme}>
			<div className="app">
				<div className="app-innerwrap">
					<Header label="Purchase Form" />
					<Form />
				</div>
				<ToastContainer position={toast.POSITION.BOTTOM_RIGHT}/>
			</div>
		</ThemeProvider>
	
	UNSAFE_componentWillMount: ()->
		saveMarketingAttrsFromHref()


export default App